import { render, staticRenderFns } from "./DeductionsModal.vue?vue&type=template&id=5896f107&lang=pug&"
import script from "./DeductionsModal.vue?vue&type=script&lang=js&"
export * from "./DeductionsModal.vue?vue&type=script&lang=js&"
import style0 from "./DeductionsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5896f107')) {
      api.createRecord('5896f107', component.options)
    } else {
      api.reload('5896f107', component.options)
    }
    module.hot.accept("./DeductionsModal.vue?vue&type=template&id=5896f107&lang=pug&", function () {
      api.rerender('5896f107', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayouts/DeductionsModal.vue"
export default component.exports